<template>
  <div class="align-items-center justify-content-center tutorial-popup">
    <div class="popup-container">
      <transition name="bounce">
        <div v-show="open" class="tutorial-wrapper">

          <div class="tutorial-window">
            <div class="header"></div>
            <div class="content">
              <EndGamePage
                  v-for="page in pages"
                  :key="page.id"
                  v-show="currentPageId === page.id"
                  :title="page.title"
                  :body="page.body"
                  :image="page.image"
                  :backImage="page.backImage"
                  :isFirstPage="page.id === 0"
                  :isLastPage="page.id === pages.length-1"
                  :pageId="page.id"
                  :buddy="buddy"
                  :showBuddy="page.hasBuddy"
                  v-on:backClicked="backClicked()"
                  v-on:forwardClicked="forwardClicked()"
              ></EndGamePage>
              <div class="pips">
                <button class="pip btn" v-for="page in pages"
                        :key="page.id"
                        :class="currentPageId === page.id? 'large' : '' "
                        @click="pipClicked(page.id)"
                ></button>
              </div>

            </div>
            <div class="footer"></div>
          </div>

          <div class="button-row">

            <WhiteOutlineButton :buttonText="currentPageId < pages.length-1 ? 'Volgende' : 'Klaar'"
                                :stretch-to-fill="false"
                                v-on:clicked="nextStepClicked"></WhiteOutlineButton>

          </div>

        </div>
      </transition>

    </div>
  </div>

</template>

<script>

import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";

import endgame1 from '@/assets/image/endgame/01_bg.png';
import endgame2 from '@/assets/image/endgame/02_bg.png';
import endgame2overlay from '@/assets/image/endgame/02_overlay.png';
import endgame3 from '@/assets/image/endgame/03.png';
import endgame4 from '@/assets/image/endgame/04.png';
import endgame5 from '@/assets/image/endgame/05_bg.png';
import endgame5overlay from '@/assets/image/endgame/05_overlay.png';

import EndGamePage from "@/components/StudentPlatform/EndGame/EndGamePage";


export default {
  name: "OutroPopup",
  components: { WhiteOutlineButton, EndGamePage },
  props: {
    open: Boolean,
    buddy: Object,
  },
  data()
  {
    return {
      show: false,
      videoLoaded: false,
      currentPageId: 0,

      pages: [
        {
          id: 0,
          title: "",
          body: `<b>${this.buddy.name}</b>: Luuk, ik heb erg veel bijgeleerd over bewegen en gezond zijn. Ik heb het hier enorm naar mijn zin maar ik denk dat het tijd wordt dat ik terug ga naar mijn vrienden in de toekomst. <br/><br/> <b>Luuk</b>: Da’s jammer, maar ik begrijp dat je hier niet eeuwig kan blijven. We zullen je alvast missen. Kunnen we nog iets doen voor jou?`,
          image: endgame1,
          backImage: null,
          hasBuddy: true,
        },
        {
          id: 1,
          title: "",
          body: `<b>${this.buddy.name}</b>: Vooral blijven bewegen! Bedankt voor alles. Ik zal jullie ook missen.`,
          image: endgame2,
          backImage: endgame2overlay,
          hasBuddy: true,
        },
        {
          id: 2,
          title: "",
          body: `De tijdsmachine van ${this.buddy.name} begint te gloeien en maakt enkele rare geluiden wanneer plots ...`,
          image: endgame3,
          backImage: null,
          hasBuddy: false,
        },
        {
          id: 3,
          title: "",
          body: "PAF... Met een luide knal verdwijnt de tijdsmachine.",
          image: endgame4,
          backImage: null,
          hasBuddy: false,
        },
        {
          id: 4,
          title: "",
          body: `<b>LUUK</b>: Waaw, wat een gek avontuur. En het leuke is dat we zelf ook veel bijgeleerd hebben. Hopelijk zien we ${this.buddy.name} ooit terug!`,
          image: endgame5,
          backImage: endgame5overlay,
          hasBuddy: true,
        },

      ]
    }
  },
  computed: {
    buddyName()
    {
      return this.buddy ? this.buddy.name : '';
    },
  },
  mixins: [],
  methods: {

    closeClicked()
    {
      this.$emit("closeClicked");
    },

    //#region carousel

    backClicked()
    {
      if (this.currentPageId <= 0)
      {
        this.currentPageId = this.pages.length - 1;
      }
      else
      {
        this.currentPageId--;
      }
    },


    forwardClicked()
    {
      if (this.currentPageId >= this.pages.length - 1)
      {
        this.currentPageId = 0;
      }
      else
      {
        this.currentPageId++;
      }
    },

    pipClicked(id)
    {
      this.currentPageId = id;
    },

    //#endregion

    nextStepClicked()
    {
      if (this.currentPageId >= this.pages.length - 1)
      {
        this.$emit("nextStepClicked");
      }
      else
      {
        this.currentPageId++;
      }
    }


  },
  mounted()
  {
    let that = this;
    that.show = true;
  },
  created()
  {
  },
}


</script>

<style lang="scss" scoped>

.tutorial-popup {
  width: 100vw;
  height: 100vh;
  position: absolute;
  //background-color: rgba(0, 0, 0, 0.8);
  background-image: url("~@/assets/image/endgame/outro_overlay_bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 9999;
  top: 0;
  left: 0;
  display: flex;

  .popup-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.tutorial-window {
  width: 50%;
  height: 50%;

  .header {
    background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom center;
    width: 600px;
    height: calc(600px * 0.086);
  }

  .content {
    //content is now fixed to allow the use of the user's buddy in tutorial images
    width: 600px;

    //width: 50vw;
    //min-height: calc(80vh - (50vw * 0.086 * 2));
    background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
    background-size: 100%;
    background-position: center center;
    position: relative;
    padding: 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

  }

  .footer {
    background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;

    width: 600px;
    height: calc(600px * 0.086);
  }

  .pips {
    display: flex;
    justify-content: center;
    align-items: center;

    .pip {
      width: 10px;
      height: 10px;
      padding: 0px;
      border-radius: 10px;
      background-color: white;
      margin: 5px;

      &.large {
        width: 15px;
        height: 15px;
      }
    }
  }
}


.bounce-enter-active {
  animation: bounce-in .5s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.button-row {
  height: 15%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

</style>